import React, { useContext, useEffect, useRef } from 'react';
import { type ExperienceSimplePleaCard } from '@bbkAdminRedux/rtkq/experience.slice';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';
import DesignElement from '@bbkFunnelComponents/design-element/design-element';
import {
  REFS_CONTEXT_FUNNEL_PREFIX,
  RefsContext,
} from '@bbkFunnelUtils/refs.context';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

import './plea.scss';

type Props = {
  card: ExperienceSimplePleaCard;
  fullWidthHeader: boolean;
};

export const Plea: React.FC<Props> = ({
  card,
  card: {
    requires: {
      plea: { title, headline },
    },
    style_overlay: customStyles,
  },
  fullWidthHeader,
}) => {
  const value = title + (headline ? ` <strong>${headline}</strong>` : '');

  const refsPrefix = REFS_CONTEXT_FUNNEL_PREFIX;
  const refsCtx = useContext(RefsContext);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(
    () => refsCtx?.addRef(`${refsPrefix}-plea`, sectionRef),
    [sectionRef]
  );

  return (
    <DesignElement name="Plea">
      <div
        className={cs('plea', makeClassNameSafe(card.name), {
          pleaFWH: fullWidthHeader,
        })}
        ref={sectionRef}
      >
        <div className="plea-title" style={customStyles.pleaTitle}>
          <CustomerHtml value={value} />
        </div>
      </div>
    </DesignElement>
  );
};
